import { Schema } from "effect";
import { WorkspaceFiles } from "@workerstation/shared/station/workspace-input";
import type { WorkspaceSnapshot } from "../../api/station/model.ts";
import type { WorkspaceDraft } from "./persistence-model.ts";

export const WorkspaceView = Schema.Struct({
  files: WorkspaceFiles, openTabs: Schema.Array(Schema.String),
  currentFile: Schema.optionalKey(Schema.String), folders: Schema.Array(Schema.String)
});
export type WorkspaceView = typeof WorkspaceView.Type;

export function inferPrimaryFile(files: Readonly<Record<string, string>>): string | undefined {
  return Object.keys(files).find(file => file === "src/index.ts" || file === "src/index.js")
    || Object.keys(files).find(file => file.endsWith(".ts") || file.endsWith(".js"))
    || Object.keys(files)[0];
}

/** Query responses are decoded by StationApi; local starter drafts are already
 * validated by persistence. This projection retains the native tab policy. */
export const workspaceView = (state: WorkspaceSnapshot | WorkspaceDraft): WorkspaceView => {
  const loadedFiles = state.files;
  const validTabs = state.openTabs.filter(tab => Object.hasOwn(loadedFiles, tab));
  const primary = inferPrimaryFile(loadedFiles);
  const currentFile = state.currentFile && Object.hasOwn(loadedFiles, state.currentFile)
    ? state.currentFile : validTabs[0] ?? primary;
  return { files: loadedFiles, openTabs: validTabs.length ? validTabs : primary ? [primary] : [],
    ...(currentFile === undefined ? {} : { currentFile }), folders: state.folders ?? [] };
};
